import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import DocumentControlHeader from "./DocumentControlHeader";

export class IncidentInvestigationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentInvestigation'}
            title={'PROCEDURE P20.0 INCIDENT INVESTIGATION'}
            exportTitle={'<h2>Procedure P20.0 Incident Investigation</h2>'}
            exportFileName={'incident_investigation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentInvestigationProcedure);